"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "pt": {
        "translation": {
            "page_header": {
                "example": "Exemplo",
                "icons": {
                    "academy": "Academia",
                    "asset_inventory": "Inventário de Ativos",
                    "assets_and_attributes": "Ativos e Atributos",
                    "assurance_plans": "Planos de Garantia",
                    "bulk_importer": "Importador em massa",
                    "compliance_maps": "Mapas de Conformidade",
                    "community": "Comunidade",
                    "frameworks": "Estruturas",
                    "issue_tracker": "Rastreador de Problemas",
                    "launchpad": "Launchpad",
                    "mission_control": "Controle da Missão",
                    "projects": "Projetos",
                    "reports": "Relatórios",
                    "results": "Resultados",
                    "robots": "Robôs",
                    "scheduler": "Agendador",
                    "storyboard": "Storyboards",
                    "strategy": "Estratégia",
                    "task_tracker": "Rastreador de Tarefas",
                    "time_sheets": "Quadros de Horário",
                    "toolkits": "Kits de ferramentas"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=pt.js.map